import React from 'react'

/*TODO: classes managements*/
const InputField = ({ input, className = 'form-control', containerClassName = 'col-xs-12', divClass='form-group', label, defaultValue, placeholder, type, autoComplete, meta: { touched, error, warning } }) => (
    <div className={ divClass }>
        { label ? <label>{ label }</label> : null }
        <div className={ containerClassName }>
            <input { ...input } className={ className } placeholder={ placeholder } type={ type } autoComplete={autoComplete} defaultValue={ defaultValue }/>
            { touched && ((error && <span className='error'>{error}</span>) || (warning && <span>{warning}</span>)) }
        </div>
    </div>
)

export default InputField


// WEBPACK FOOTER //
// ./src/client/features/form/components/InputField.jsx